<template>  
  <div id="homep" v-loading="loading">    
    <div id="p0">
      <img :src="logo"/>   
      <el-popover        
        placement="bottom"
        width="160"
        trigger="click">
        <div @click="changLang('cn')" class='langit'>
          <img :src="md0icn" />
          简体中文
          <img v-if="iscn" :src="md0lanck" class="md0check" />
        </div>
        <div @click="changLang('en')" class='langit'>
          <img :src="md0ien" />
          English
          <img v-if="!iscn" :src="md0lanck" class="md0check" />
        </div>          
        <img style="width:.22rem;height:.22rem;margin:.14rem .16rem 0 0;float:right;" slot="reference" :src='langic' />          
      </el-popover>         
    </div>
    <div id='p1'>
      <img :src="p1bg"/>
      <div>Digital Twin Platform for Site Management</div>
      <label v-show="iscn">JARVIS 360鹰眼数字化智慧工地监管系统</label>      
      <img :class="pk(['p1imgmg','p1imgmg_en'])" :src="p1img0"/>
      <img :src="p1sp"/>
      <img :src="pk([p1img1,p1img1_en])"/>
    </div>
    <div id='p2'>
      <img :src="p2bg" />
      <div v-show="iscn" id='p2tt'>为你和现场提供『身历其境』的连接</div>
      <div :id="pk(['p2desc','p2descen'])">Connect you and remote site seamlessly</div>
      <div class="p2fr" v-for="i in p2data" :key="i.title">
        <img :src="i.icon" />
        <div>{{i.title}}</div>
        <img :src="p2sp" />
        <label>{{i.desc}}</label>
      </div>
    </div>
    <div id='p3'>
      <img :src="pk([p3i0, p3i0_en])"/>
      <img :src="pk([p3i1, p3i1_en])"/>
    </div>
    <div id='p4'>
      <div v-if="iscn">让你<b>巨细无遗</b>检视工程的每一个细节</div>
      <div v-else><b>Capture the work in 3DVR</b></div>
      <label>{{lan.md3desc}}</label>
      <img :src="p4img" />
    </div>
    <div id='p5'>
      <div>{{lan.md4title}}</div>
      <div>{{lan.md4desc}}</div>
      <img :src="p5img0" />
      <img :src="pk([p5img1,p5img1_en])" />
    </div>
    <div id='p6'>
      <div>{{iscn?lan.md5title:'Connect project past and future'}}</div>
      <div v-show="iscn">Connect project past and future</div>
      <el-carousel id='p6card' indicator-position="none" @change="cardChange">
        <el-carousel-item v-for="item in md5as" :key="item">                
          <img :src="item" />
        </el-carousel-item>
      </el-carousel>
      <label >{{md5awds[cidnex]}}</label>
      <div id='p6lb'>
        <span id='p6lbfr' :style="'margin-left:-'+tpmg+'px;'">          
          <img class="lbimg" v-for="(img,index) in md5bs" :key="index" :src="img" />   
        </span>          
      </div>      
    </div>
    <div id='p7'>
      <div>
        {{lan.md6title}}
      </div>
      <div>
        {{lan.md6desc}}
      </div>
      <img :src="p7bg" />      
    </div>
    <div id='p8'>
      <div class="p8cmfr">
        <img :src="md6b0" />
        <div>{{lan.md6c0title}}</div>
        <img :src="md6bid1" />
        <div>{{lan.md6c0desc}}</div>
      </div>
      <img :src="p8di" />
      <div class="p8cmfr">
        <img :src="md6b1" />
        <div>{{lan.md6c1title}}</div>
        <img :src="md6bid1" />
        <div>{{lan.md6c1desc}}</div>
      </div>
      <img :src="p8di" />
      <div class="p8cmfr">
        <img :src="md6b2" />
        <div>{{lan.md6c2title}}</div>
        <img :src="md6bid1" />
        <div>{{lan.md6c2desc}}</div>
      </div>      
    </div>
    <div id='p9'>
      <img v-if='iscn' id="p9img" :src="p9img" />
      <img v-else id="p9img_en" :src="p9img_en" />
      <div :class="iscn?'p9w':''">{{lan.title}}</div>      
    </div>
    <div id='p10'>
      <img :src="p10img" />
      <div>
        <label>isBIM Limited</label>
        <label>{{lan.md6ctaddr}}</label>
        <label>{{lan.md6cttel}}</label>
        <label>{{lan.md6ctemail}}</label>              
      </div>
    </div>
    <div id='p11'>
      Powered by JARVIS DTE © 2020
    </div>

  </div>
</template>

<style>    
  #homep {
    background: black;  
    overflow: hidden;  
    width: 100%;   
    color: white;    
  }
  #p0 {
    height: .5rem;
    background: #121B53;  
    overflow: scroll;     
  }
  #p0 img {        
    display: inline-block;           
  }
  #p0 img:nth-child(1) {
    width: 1.3rem;
    height: .48rem;
    float: left;
    margin-top: .01rem;
  } 
  /* #p0 img:nth-child(2) {    
    width:.22rem;margin:.14rem .16rem 0 0;float:right;position:relative;   
  } */
  #p1 {
    overflow: hidden;    
    width: 100%;           
    position: relative;
    height: 6.38rem;    
  }
  #p1 img {
    position: absolute;  
    z-index: 10; 
  }
  #p1 img:nth-child(1) {
    height: 3.21rem;
    width: 100%;    
    z-index: 0;
  }
  #p1 img:nth-child(4) {    
    width: 2.97rem;
  }
  .p1imgmg {
    margin: 1.37rem 0 0 .55rem;
  }
  .p1imgmg_en {
    margin: 1.17rem 0 0 .55rem;
  }
  #p1 img:nth-child(5) {    
    width: 100%;    
    margin: 3.2rem 0 0 0;
  }
  #p1 img:nth-child(6) {    
    width: 4rem;
    margin: 3.57rem 0 0 .02rem;
  }
  #p1 div {
    font-size: .24rem;    
    position: absolute;
    z-index: 10;
    width: 3.21rem;
    text-align: center;
    font-weight: 800;    
    margin: .16rem 0 0 .47rem;         
  }
  #p1 label {
    width: 100%;
    text-align: center;  
    font-size: .18rem;    
    font-weight: 300;    
    position: absolute;
    margin-top: .9rem;    
  }
  #p2 {    
    background: #EEF6FF;
    overflow: hidden;          
  }
  #p2 img:nth-child(1) {
    width: .51rem;
    margin: .26rem 0 0 .18rem;
    position: absolute;
  }  
  #p2tt {    
    font-size: .22rem;
    font-weight: bold;
    color: #000000;
    margin: .40rem 0 0 .15rem;
    position: absolute;
  }
  #p2desc {
    position: absolute;
    margin: .79rem 0 0 .18rem;
    font-size: .16rem;
    font-weight: 300;
    color: #000000;
  }
  #p2descen {
    position: absolute;
    margin: .44rem 0 0 .18rem;
    width: 3.75rem;
    font-size: .22rem;
    font-weight: bold;
    color: #000000;
  }
  .p2fr {
    margin: 0rem .18rem .16rem .17rem;    
    background: #FFFFFF;
    box-shadow: 0px 0px .1rem 0px rgba(49, 70, 104, 0.3);
    border-radius: .06rem;        
    overflow: hidden;
    padding: 0 .18rem .24rem .18rem;
  }
  #p2 div:nth-child(4) {    
    margin-top: 1.22rem;
  } 
  #p2 div:nth-child(7) {    
    margin-bottom: .3rem;
  } 
  .p2fr img:nth-child(1) {    
    width: .48rem;
    display: block!important;      
    position: relative!important;
    margin: .24rem 0 .08rem 0!important;              
  }
  .p2fr img:nth-child(3) {    
    width: 1.08rem;
    display: block;   
    margin: .08rem 0 .16rem 0;    
  }
  .p2fr div {
    font-size: .24rem;
    font-weight: 800;
    color: #000000;    
    display: block;
    position: relative;
  }
  .p2fr label {
    font-size: .18rem;
    font-weight: 300;
    color: #494949;
    display: block;    
  }
  #p3 {
    text-align: center;
    padding: .26rem 0 .24rem 0;
  }
  #p3 img {
    display: block;
    margin: 0 auto;    
  }
  #p3 img:nth-child(1) {
    width: 3.88rem;
  }
  #p3 img:nth-child(2) {
    width: 3.92rem;
  }
  #p4 {
    padding: .34rem 0 .29rem 0;    
    background: #EEF6FF;;
    text-align: center;
  }
  #p4 div {        
    font-size: .22rem;    
    font-weight: 400;
    color: #000000;
  }
  #p4 label {
    display: block;   
    width: 3.79rem; 
    margin: .08rem auto .12rem auto;
    font-size: .14rem;    
    font-weight: 300;
    color: #000000;
  }
  #p4 img {
    width: 3.87rem;
    display: block;
    margin: 0 auto;
  }
  #p5 {
    padding: .4rem 0 .34rem 0;
    text-align: center;    
    position: relative;
    overflow: hidden;    
  }
  #p5 div:nth-child(1) {
    width: 3.3rem;    
    font-size: .23rem;    
    font-weight: 800;
    color: #FFFFFF;
    text-align: center;    
    margin: 0 auto;        
  }
  #p5 div:nth-child(2) {
    width: 3.79rem;
    font-size: .14rem;
    font-weight: 400;
    color: #FFFFFF;
    margin: .08rem auto .16rem auto;
  }
  #p5 img:nth-child(3) {
    width: 3.8rem;
    display: block;    
    margin: 0 auto;
  }
  #p5 img:nth-child(4) {
    width: 3.73rem;
    display: block;    
    margin: .09rem auto;
  }
  #p6 {
    padding: .32rem 0 .32rem 0;
    background: #EEF6FF;
  }
  #p6 div:nth-child(1) {
    width: 2.41rem;    
    font-size: .22rem;
    font-weight: bold;
    color: #000000;   
    margin-left: .18rem; 
  }
  #p6 div:nth-child(2) {    
    font-size: .16rem;    
    font-weight: 300;
    color: #000000;
    margin: .08rem 0 .06rem .18rem;
  } 
  #p6card {    /** .el-carousel */
    height: 1.95rem; 
    overflow: hidden;   
    margin-top:.1rem;      
  }
  #p6card button {        
    opacity: 0;
  }
  #p6card .el-carousel__item {    
    width: 3.8rem;        
  }
  #p6card .el-carousel__item img {
    width: 100%;    
  }   
  #p6 label{    
    width: 3.40rem;        
    font-size: .16rem;    
    font-weight: 500;
    color: #111437;
    margin: .08rem 0 .16rem .47rem;
    text-align: center;    
    display: block;
  }
  #p6lb {
    width: 3.79rem;
    height: 1.24rem;
    background: linear-gradient(180deg, #0D1765 0%, #0C1028 100%);
    border-radius: .08rem;
    margin-left: .18rem; 
    overflow: hidden;       
    white-space: nowrap;
  }
  #p6lb img {
    width: 1.75rem;
  }
  #p7 {
    padding: .4rem 0 0 0;
    background: #0C1028;
    text-align: center;
  }
  #p7 div:nth-child(1) {
    width: 2.64rem;
    font-size: .22rem;
    font-weight: 800;
    color: #FFFFFF;
    margin-left: .75rem;
  }
  #p7 div:nth-child(2) {
    width: 3.79rem;    
    font-size: .14rem;    
    font-weight: 400;
    color: #FFFFFF;
    margin: .08rem 0 0 .18rem;
  }
  #p7 img {
    width: 3.49rem;
    display: block;
    margin-left: .24rem;    
  }
  #p8 {
    overflow: hidden;
    background:#0C1028;
  }
  #p8 img:nth-child(2n) {    
    width: .82rem;
    margin: .1rem 0 -.15rem 1.66rem;    
    display: block;
  }
  .p8cmfr {
    padding:0 .36rem 0 .36rem;        
  }
  .p8cmfr img:nth-child(1) {
    width: 3.42rem;
    display: block;       
  }
  .p8cmfr div:nth-child(2) {
    margin: -.1rem 0 0 .26rem;    
    font-size: .28rem;    
    font-weight: 800;
    color: #FFFFFF;    
  }
  .p8cmfr img:nth-child(3) {
    width: 1.2rem;
    display: block;       
    margin: .08rem 0 .16rem .26rem;
  }
  .p8cmfr div:nth-child(4) {    
    width: 2.8rem;    
    font-size: .2rem;    
    font-weight: 300;
    color: #D6DBE8;
    margin-left: .26rem;    
  }
  #p9 {
    overflow: hidden;
    background:#0C1028;
    padding: .4rem 0 .48rem 0;
    text-align: center;
  }
  #p9img {
    margin: 0 0 .1rem .43rem;
    width: 2.94rem;
    display: block;
  }
  #p9img_en {
    margin: 0  0 .1rem .82rem;
    width: 2.17rem;
    display: block;
  }
  #p9 div {        
    font-size: .16rem;    
    font-weight: bold;
    color: #FFFFFF;
    margin: 0 auto;
  }
  .p9w {
    letter-spacing: .07rem;
  }  

  #p10 {
    overflow: hidden;
    background: black;
  }
  #p10 img {
    display: block;
    margin: .15rem 0 .07rem .09rem;
    width: 2.26rem;    
  }
  #p10 div {
    margin-left: .18rem;    
  }
  #p10 label {        
    font-size: .14rem;    
    font-weight: 400;
    color: #FFFFFF;
    display: block;
  }
  #p11 {
    overflow: hidden;
    background: black;
    text-align: center;
    padding: .32rem 0 .16rem 0;
    font-size: .12rem;
    font-weight: 300;
    color: #D6DBE8;
  }



 
</style>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import en from '@/components/en.js'
import cn from '@/components/cn.js'
export default {  
  components: {
    // HelloWorld
  },
  computed: {    
    p2data () {
      return [
        {
          icon: require('../assets/md1i1.png'), 
          title: this.lan.md1c1title, 
          desc: this.lan.md1c1desc
        },
        {
          icon: require('../assets/md1i2.png'), 
          title: this.lan.md1c2title, 
          desc: this.lan.md1c2desc
        },
        {
          icon: require('../assets/md1i0.png'), 
          title: this.lan.md1c0title, 
          desc: this.lan.md1c0desc
        },
        {
          icon: require('../assets/md1i3.png'), 
          title: this.lan.md1c3title, 
          desc: this.lan.md1c3desc
        }
      ]
    },
    lang () {
      return localStorage.lang
    },
    iscn () {
      return this.lang == 'cn'
    },
    md5awds () {        
      return [
        this.lan.md5d0,this.lan.md5d1,this.lan.md5d2
      ]
    },
    md5bs () {
      return this.iscn? [
        require('../assets/md5v0.png'), 
        require('../assets/md5v1.png'), 
        require('../assets/md5v2.png'), 
        require('../assets/md5v3.png'), 
        require('../assets/md5v4.png'), 
        require('../assets/md5v5.png'), 
        require('../assets/md5v6.png'), 
        require('../assets/md5v7.png'),
        require('../assets/md5v0.png'),
        require('../assets/md5v1.png'),
      ] : [
        require('../assets/md5v0_en.png'), 
        require('../assets/md5v1_en.png'), 
        require('../assets/md5v2_en.png'), 
        require('../assets/md5v3_en.png'), 
        require('../assets/md5v4_en.png'), 
        require('../assets/md5v5_en.png'), 
        require('../assets/md5v6_en.png'), 
        require('../assets/md5v7_en.png'),
        require('../assets/md5v1_en.png'),
        require('../assets/md5v2_en.png'),
      ]
    }
  },
  data() {
    return {
      lan: {},
      loading: false,  
      cidnex: 0,       
      logo: require('../assets/phone/logo.png'),    
      langic: require('../assets/lang.png'), 
      p1bg: require('../assets/phone/p1bg.png'),  
      p1sp: require('../assets/phone/p1sp.png'),  
      p1img0: require('../assets/phone/p1img0.png'),        
      p1img1: require('../assets/phone/p1img1.png'),  
      p1img1_en: require('../assets/phone/p1img1_en.png'),  
      p2bg: require('../assets/phone/p2bg.png'),   
      p2sp: require('../assets/md1ib.png'),   
      p3i0: require('../assets/phone/p3i0.png'),   
      p3i0_en: require('../assets/phone/p3i0_en.png'),   
      p3i1: require('../assets/phone/p3i1.png'),   
      p3i1_en: require('../assets/phone/p3i1_en.png'),   
      p4img: require('../assets/phone/p4img.png'),   
      p5img0: require('../assets/phone/p5img0.png'),   
      p5img1: require('../assets/phone/p5img1.png'),   
      p5img1_en: require('../assets/phone/p5img1_en.png'),   
      p7bg: require('../assets/phone/p7bg.png'),   
      p8di: require('../assets/phone/p8di.png'),  
      md6b0: require('../assets/md6b0.png'), 
      md6b1: require('../assets/md6b1.png'),     
      md6b2: require('../assets/md6b2.png'), 
      md6bid1: require('../assets/md6bid1.png'),  
      p9img: require('../assets/phone/p9img.png'),  
      p9img_en: require('../assets/phone/p9img_en.png'),  
      p10img: require('../assets/phone/p10img.png'), 
      md0ien: require('../assets/md0ien.png'),    
      md0icn: require('../assets/md0icn.png'), 
      md0lanck: require('../assets/md0lanck.png'),  
      md5as: [
        require('../assets/md50.png'),
        require('../assets/md51.png'),
        require('../assets/md52.png')
      ],
      md5asl: 0,    
      tpmg: 0      
    };
  },
  methods: {
    changLang (lang) {
      localStorage.lang = lang
      location.reload(true)
    },
    lbPlay () {
      var _this = this
      var o = document.getElementById("p6lb");            
      var width = o.offsetWidth; //宽度    
      var o1 = document.getElementById("p6lbfr");            
      var width1 = o1.offsetWidth; //宽度      
      var o2 = document.getElementsByClassName("lbimg")[0];       
      setInterval(() => {
        if (_this.tpmg < width1-width+o2.offsetWidth/5.55) { //700  1145
          _this.tpmg += 3
        } else {
          _this.tpmg = 0
        }
      }, 100);
    },
    cardChange (index) {
      this.cidnex = index
    },
    pk (arr) {      
      return this.iscn? arr[0]:arr[1]
    },
    setRem() {
        var html = document.querySelector('html');
        var width = html.getBoundingClientRect().width;
        html.style.fontSize = width/4.2 + 'px'; /// 69                    
    },
    initWindowEv () {
      /// rem=px/2/14
      window.addEventListener('orientationchange', this.setRem);
      window.addEventListener('resize', this.setRem);
      this.setRem();  
    }
  },
  mounted() {    
    if (!this.lang) {
      if (navigator.language == 'zh-cn' || navigator.language == 'zh-CN') {      
        localStorage.lang = 'cn'              
        this.lan = cn
      } else {            
        localStorage.lang = 'en'              
        this.lan = en
      }  
    } else {
      this.lan = this.iscn?cn:en 
    }                    
    this.initWindowEv() 
    this.lbPlay()
        
  },
};
</script>
